import React, { Fragment } from 'react'
import { Navigate, useParams } from 'react-router-dom'

import styles from './VerifyTranscriptEmail.module.css'

import EntryForm, { EntryFormContainer } from 'Layout/EntryForm'
import Heading from 'Design/components/Heading'
import Spinner from 'Design/components/Spinner'
import Link from 'Design/components/Link'

import { useVerifyTranscriptEmailQuery } from './verify-transcript-email.service'

const InProgress = () => {
  return (
    <Fragment>
      <Spinner className={styles.StatusIcon} />
      <p>
        Please wait... <br />
        We are verifying your email...
      </p>
    </Fragment>
  )
}

const Error = () => {
  return (
    <Fragment>
      <Heading className={styles.StatusIcon}>😕</Heading>
      <p>
        Transcript email token expired or invalid <br />
        Try again or contact <Link href='mailto:support@happyfox.com'>support@happyfox.com</Link>
      </p>
    </Fragment>
  )
}

const VerifyTranscriptEmail = () => {
  const { token } = useParams()

  const { isLoading, isError, isSuccess } = useVerifyTranscriptEmailQuery(token)

  if (isSuccess) {
    return <Navigate to='/dashboard' replace />
  }

  return (
    <EntryForm>
      <EntryFormContainer className={styles.ProgressContainer}>
        {isLoading && <InProgress />}
        {isError && <Error />}
      </EntryFormContainer>
    </EntryForm>
  )
}

export default VerifyTranscriptEmail
